export const simplifyTextString = (s) => s?.trim()?.toLowerCase() || "";
